import React, { useState } from 'react';
import icons from '@icons';
import { Picture } from '@ui';
import { Link, useLocation } from '@compat/router';
import './index.scss';

const {
  pricetag: {
    midYellow: pricetagMDFilled,
    red: pricetagRedFilled,
    black: pricetagBlackFilled
  },
  // store: { red: storeRedFilled, black: storeBlackFilled },
  fire: { red: fireRedFilled, black: fireBlackFilled }
} = icons.Fill;

const {
  chevronDown: { midGrey: chevronDownMGOutlined },
  percent: { red: percentRedOutlined, black: percentBlackOutlined }
} = icons.Outline;

export const promosLinksList = [
  {
    id: 0,
    title: 'Акции',
    href: '/promotions',
    icon: percentBlackOutlined,
    iconHover: percentRedOutlined
  },
  {
    id: 1,
    title: 'Скидки',
    href: '/catalog/promo',
    icon: fireBlackFilled,
    iconHover: fireRedFilled
  },
  {
    id: 2,
    title: 'Распродажа',
    href: '/catalog/rasprodazha',
    icon: pricetagBlackFilled,
    iconHover: pricetagRedFilled
  }
  // { id: 1, title: 'Магазин', href: '/promotions/1292', icon: storeBlackFilled, iconHover: storeRedFilled },
];

const PromosBtn = () => {
  // ЭТАП 1 · Шаг 3 — гидрация: bare `location` в рендере — на сервере это шим
  // (локация роутера), на клиенте window.location; useLocation читает один и
  // тот же источник на обеих сторонах + реактивен при навигации.
  const location = useLocation();
  const [curIcons, setCurIcons] = useState({
    0: { icon: percentBlackOutlined },
    1: { icon: fireBlackFilled },
    2: { icon: pricetagBlackFilled }
    // 1: { icon: storeBlackFilled },
  });
  const onMouseEnter = id => {
    setCurIcons(prev => ({
      ...prev,
      [id]: { icon: promosLinksList[id].iconHover }
    }));
  };
  const onMouseLeave = id => {
    setCurIcons(prev => ({
      ...prev,
      [id]: { icon: promosLinksList[id].icon }
    }));
  };

  return (
    <div className='promos-btn'>
      <Picture
        className='promos-btn__icon'
        icon={pricetagMDFilled}
        height='20'
        width='20'
      />
      <div className='promos-btn__text'>Скидки</div>
      <Picture
        className='promos-btn__chevron'
        icon={chevronDownMGOutlined}
        height='20'
        width='20'
      />
      <div className='promos-btn__wrapper'>
        <div className='promos-btn__wrapper__list'>
          {promosLinksList?.map(item => {
            const isActive = location.pathname === item.href;
            return (
              <Link
                key={item.id}
                to={item.href}
                onMouseEnter={() => onMouseEnter(item.id)}
                onMouseLeave={() => onMouseLeave(item.id)}
                className={`promos-btn__wrapper__item${
                  isActive ? ' promos-btn__wrapper__item--active' : ''
                }`}
              >
                <Picture
                  pictureClassName='promos-btn__wrapper__item__icon'
                  icon={
                    isActive
                      ? promosLinksList[item.id].iconHover
                      : curIcons[item.id].icon
                  }
                  height='24'
                  width='24'
                />
                {item.title}
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default PromosBtn;
